import { gql, TypedDocumentNode } from '@apollo/client';

export type GetCuratedLooksQuery = {
  curatedLooks: {
    __typename: 'RestCuratedLooksResponse';
    data: CuratedLook[];
    meta: {
      pagination: Pagination;
    };
  };
};

export type CuratedLookItem = {
  color: string;
  id: number;
  productId: number;
  quantity: number;
  size: string;
  skuId: number;
  status: string;
  trunkshowId: number;
  userId: number;
  variantId: number;
  position: number;
  itemType: string;
  title: string | null;
  imageKey: string | null;
};

export type CuratedLook = {
  id: number;
  name: string;
  items: CuratedLookItem[];
  userId: number;
  shared: boolean;
  status: string;
  stylistName: string;
  headerMessage: string | null;
  headerImage: string | null;
  createdAt: string;
  updatedAt: string;
};

type Pagination = {
  currentPage: number;
  totalEntries: number;
  previousPage: number | null;
  nextPage: number | null;
  perPage: number;
  totalPages: number;
};

export type GetCuratedLooksVariables = {
  page?: number;
  perPage?: number;
};

const PAGINATION_FRAGMENT = gql`
  fragment CuratedLooksPaginationFragment on RestCuratedLooksMeta {
    pagination @type(name: "RestCuratedLooksPagination") {
      currentPage: current_page
      totalEntries: total_entries
      previousPage: previous_page
      nextPage: next_page
      perPage: per_page
      totalPages: total_pages
    }
  }
`;

export const GET_CURATED_LOOKS_QUERY: TypedDocumentNode<
  GetCuratedLooksQuery,
  GetCuratedLooksVariables
> = gql`
  query GetCuratedLooksQuery($page: Int, $perPage: Int) {
    curatedLooks(page: $page, perPage: $perPage)
      @rest(
        type: "RestCuratedLooksResponse"
        endpoint: "moda"
        path: "/v3.5/shoppable_edits?page={args.page}&per_page={args.perPage}&shared=true"
        method: "GET"
      ) {
      data @type(name: "RestCuratedLooks") {
        id
        name
        items {
          color
          id
          productId: product_id
          quantity
          size
          skuId: sku_id
          status
          trunkshowId: trunkshow_id
          userId: user_id
          variantId: variant_id
          position
          title
          itemType: item_type
          imageKey: image_key
        }
        userId: user_id
        shared
        status
        updatedAt: updated_at
        createdAt: created_at
        stylistName: stylist_name
        headerImage: header_image_key
        headerMessage: header_message
      }
      meta @type(name: "RestCuratedLooksMeta") {
        ...CuratedLooksPaginationFragment
      }
    }
  }
  ${PAGINATION_FRAGMENT}
`;
